"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const edit = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-edit" : '') + (description ? " desc-edit" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-edit"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-edit"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2141)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.12 4.502C10.534 4.502 10.87 4.838 10.87 5.252C10.87 5.666 10.534 6.002 10.12 6.002H2.62C2.206 6.002 1.87 6.338 1.87 6.752V21.752C1.87 22.166 2.206 22.502 2.62 22.502H17.62C18.034 22.502 18.37 22.166 18.37 21.752V14.252C18.37 13.838 18.706 13.502 19.12 13.502C19.534 13.502 19.87 13.838 19.87 14.252V21.752C19.87 22.993 18.861 24.002 17.62 24.002H2.62C1.379 24.002 0.369995 22.993 0.369995 21.752V6.752C0.369995 5.511 1.379 4.502 2.62 4.502H10.12ZM20.62 0.0019989C21.422 0.0019989 22.176 0.313999 22.741 0.879999C23.911 2.05 23.911 3.953 22.741 5.123L13.195 14.669C13.081 14.783 12.931 14.858 12.772 14.881L9.059 15.412C9.02299 15.416 8.988 15.419 8.953 15.419C8.753 15.419 8.564 15.341 8.423 15.199C8.257 15.033 8.178 14.795 8.211 14.563L8.741 10.85C8.764 10.69 8.83899 10.54 8.953 10.426L18.499 0.879999C19.065 0.313999 19.818 0.0019989 20.62 0.0019989ZM20.62 1.503C20.219 1.503 19.842 1.659 19.559 1.942L10.19 11.311L9.837 13.785L12.312 13.431L21.681 4.062C22.266 3.477 22.266 2.526 21.681 1.941C21.398 1.658 21.022 1.503 20.62 1.503Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2141"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = edit;